export default "__VITE_ASSET__8f31a164__"